import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Button from 'components/Base/Button';
import Intro from 'components/Intro/Intro';
import SignerOnFinalPage from 'components/SendDocuments/SignerOnFinalPage';
import ROUTES from 'constants/routes';
import { SignerFlow } from 'constants/signNow';
import { clearFullSignNowStore } from 'store/actions/signNow';
import { RootStateType } from 'store/reducers';
import sendDocumentsFinalLogo from 'svg/sendDocumentsFinalLogo.png';
import { SignersInfoType } from 'types/SendDocuments';
import { getManagerLink } from 'utils/sendDocumentsHelpers';
import { getManagerPositionFromSignersInfo } from 'utils/signNow/assignmentsHelper';

const SendDocumentsFinal = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const managerEmail = useSelector((state: RootStateType) => state.profile.profileInfo.email);
  const {
    initialLocation,
    signersInfo,
    executedDocId,
    onlyCollection,
    documentsInfo,
  } = useSelector((state: RootStateType) => state.sendDocuments);
  const {
    files,
    isSignNow,
    currentFlow,
    isRemindDocumentActive,
    isRemindForAllSigners,
  } = useSelector((state: RootStateType) => state.signNow);

  useEffect(() => () => {
    if (files && files.length === 1) {
      dispatch(clearFullSignNowStore());
    }
  }, [dispatch, files]);

  // It means it's not a collection in sign now flow
  const isRegularSignNowFlow = executedDocId
    && !onlyCollection
    && ((isSignNow && files.length === 1) || (!isSignNow && documentsInfo.length === 1));
  // Getting logged in manager position is signers order
  const managerPosition = getManagerPositionFromSignersInfo(signersInfo, managerEmail);

  const getFinalMessage = () => {
    const isNotFillAndSignPage = (
      currentFlow === SignerFlow.OrderedSigning && managerPosition !== 0
    ) || !Number.isInteger(managerPosition);

    return (isRegularSignNowFlow && !isNotFillAndSignPage) ? 'Go to document' : 'Go to dashboard';
  };

  const handlerCloseButton = () => {
    if (isSignNow && signersInfo.length) {
      if (
        ((currentFlow === SignerFlow.NoOrder && managerPosition !== null) || managerPosition === 0)
        && files.length === 1
      ) {
        return history.push(getManagerLink(executedDocId));
      }
      return history.push(initialLocation || ROUTES.DASHBOARD);
    }
    if (isRegularSignNowFlow) {
      history.push(getManagerLink(executedDocId));
    } else if (initialLocation?.includes(ROUTES.COLLECTIONS_EDITOR)) {
      history.push(ROUTES.DASHBOARD);
    } else {
      history.push(initialLocation || ROUTES.DASHBOARD);
    }
  };

  return (
    <Intro
      logoSource={sendDocumentsFinalLogo}
      title="Congratulations!"
      description="You have sucessfully sent the document(s) to"
      descriptionWidth="large"
      styles={{ logo: { width: '115px', height: '157px' } }}
    >
      <div className="send-documents-final">
        <div className="mb-4 pt-2">
          {
            signersInfo.map((signer: SignersInfoType, index: number) => (
              (isSignNow && isRemindDocumentActive && !isRemindForAllSigners && signer.signed) || !signer.email
                ? null
                : (
                  <SignerOnFinalPage
                    key={`SignerOnFinalPage${index + 1}`}
                    signer={signer}
                  />
                )
            ))
          }
        </div>
        <div className="d-flex justify-content-center">
          <Button
            classes="button-contained-pink"
            onClick={handlerCloseButton}
          >
            {getFinalMessage()}
          </Button>
        </div>
      </div>
    </Intro>
  );
};

export default SendDocumentsFinal;